var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('collapse',{attrs:{"collapsable":false,"title":_vm.$t('_.credit_notes'),"icon":"credit-card"}},[_c('credit-notes-table',{attrs:{"id":"CN1","data-scope":"credit-notes"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }